import { LocationQueryRaw, RouteLocationRaw } from '#vue-router';

export const isInternalURL = (url: string): boolean => {
  /**
   * @see Regex101 expression: {@link https://regex101.com/r/1y7iod/1}
   */
  const isInternal = /^\/(?!\/)/.test(url);
  /**
   * @see Regex101 expression: {@link https://regex101.com/r/RnUseS/1}
   */
  const isSpecialLink = !isInternal && !/^https?:\/\//i.test(url);

  return isInternal && !isSpecialLink;
};

export const linkToPlp = (path?: string, query?: LocationQueryRaw): RouteLocationRaw => {
  if (!path) return '';
  const slug = path.split('/');

  return {
    name: `kategorier-slug`,
    params: { slug },
    query,
  };
};

export const linkToPdp = (slug: string): RouteLocationRaw => {
  return {
    name: 'produkt-slug',
    params: { slug },
  };
};

export const linkToSerp = (searchString: string): RouteLocationRaw => {
  return {
    name: 'search',
    query: { q: searchString },
  };
};

export const linkToStorePage = (id: string): RouteLocationRaw => {
  return {
    params: { id },
    name: 'store',
  };
};

export const linkToCampaignPage = (slug: string): RouteLocationRaw => {
  return {
    name: 'kampanjer-slug',
    params: { slug },
  };
};

export const linkToAssortmentPage = (slug: string): RouteLocationRaw => {
  return {
    path: `/sortiment/${slug}`,
    params: { slug },
  };
};

export const linkToContentPage = (parent: string, slug: string): RouteLocationRaw => {
  parent = parent.replaceAll('/', '');
  return {
    path: `/${parent}/${slug}`,
  };
};

export const linkToOrderHistoryPage = (orderNumber: string): RouteLocationRaw => {
  return {
    name: 'order-history-page',
    params: { orderNumber },
  };
};

export const linkToShoppingList = (id: string): RouteLocationRaw => {
  return {
    name: 'shopping-list-page',
    params: { id },
  };
};

export const linkToEditUser = (userId: string): RouteLocationRaw => {
  return {
    name: 'user-administrator-edit-user',
    params: { userId },
  };
};

export const transformPlpSlug = (slug: string | string[]) => {
  let transformedSlug = '';
  if (typeof slug === 'string') {
    // When page is reloaded
    transformedSlug = slug;
  } else {
    // When user navigates by category menu
    transformedSlug = slug?.join('/') ?? '';
  }
  return transformedSlug;
};
